import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { selectInfo } from './features/infoSlice'
import Header from './Header';
import {Adjust, CheckCircle, Error, Flight, FlightLand, FlightTakeoff, Home } from '@mui/icons-material';
import './popup.css'
import { Link, useNavigate } from 'react-router-dom';
import secu from './img/secu.png'
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

function Popups() {

    const info = useSelector(selectInfo) 

    const lat =  info?.tracker.map1 ? parseInt( info?.tracker.map1) : 0.00
    const lng =  info?.tracker.map1 ? parseInt( info?.tracker.map2) : 0.00

    const center = [lat, lng]
    const ZOOM_LEVEL = 9

    const mapref = useRef()
    
    const navigate = useNavigate()

    useEffect(()=>{
        if(!info?.tracker.status){
          navigate('/')
        }

    },[info?.tracker, navigate])


  return (
    <div className='track'>
      <Header/>

      {
        info?.tracker != null?
        <div className='track_bod1'>
        <div className='track_bod'>
          <div onClick={()=>navigate('/pdffile')} className='track_btn2'>
            <h3>View Receipt</h3>
          </div>
          <div className='track_head'>

            <div className='trach_subhead'>
              <div className='track_sub'>
                <h3>INVOICE</h3>
                <p>#809</p>
              </div>

              <div className='track_sub'>
                <h3>Expected Arrival</h3>
                <p>{info?.tracker.time}</p>
              </div>
            </div>

            <div className='trach_subhead'>
              <div className='track_sub'>
                <h3>STATUS</h3>
                <p>{info?.tracker.status}</p>
              </div>

              <div className='track_sub'>
                <h3>Tracking No.</h3>
                <p>{info?.tracker.trackid}</p>
              </div>
            </div>
          </div>


        <div className='flip'>
                <div className='flip_icon'>
                {
                    info?.tracker.fst ?
                    <CheckCircle id='icons'/>
                    :
                    <div className='mark_spacer'></div>
                }
                </div>

                <div className='box'>

                    {
                      info?.tracker.sec ?
                        <div className='flip_icon2' >
                            <div className='mark_spacer_'></div>
                            <CheckCircle id='icon'/>
                        </div>
                        :
                        <div className='flip_icon' >
                            <div className='mark_spacer_'></div>
                            <CheckCircle id='iconc'/>
                        </div>
                    }

                    
                </div>

                <div className='box'>
                    {
                      info?.tracker.trd?
                        <div className='flip_icon2'>
                            <div className='mark_spacer_' ></div>
                            <CheckCircle id='icon'/>
                        </div>
                        :
                        <div className='flip_icon'>
                            <div className='mark_spacer'></div>
                            <CheckCircle id='iconc'/>
                        </div>
                    }
                </div>

                <div className='box'>
                    {
                      info?.tracker.frt?
                        <div className='flip_icon2'>
                            <div className='mark_spacer_'></div>
                            <Adjust id='icon'/>
                        </div>
                        :
                        <div className='flip_icon' >
                            <div className='mark_spacer'></div>
                            <Adjust id='iconc'/>
                        </div>
                    }
                </div>


        </div>


        <div className='flip2'>
            <div className='flip_icon'>
                {
                    !info?.tracker.fst?
                    <div className='sail'>
                      <Error id='icon_'/>
                      <small>shipped</small>
                    </div>
                    :
                    <div className='sail'>
                    <FlightTakeoff id='icon_'/>
                    <small>confirmed</small>
                    </div>
                }
            </div>

            <div className='flip_icon'>
                {
                  info?.tracker.sec?
                   <div className='sail'>
                    <Flight id='icon_'/>
                    <small>shipped</small>
                   </div>
                    :
                    <div className='sail'>
                      <Error id='icon_'/>
                      <small>pending</small>
                    </div>
                }
            </div>

            <div className='flip_icon'>
                {
                  info?.tracker.trd?
                    <div className='sail'>
                    <FlightLand id='icon_'/>
                    <small>sailing</small>
                    </div>
                    :
                    <div className='sail'>
                      <Error id='icon_'/>
                      <small>pending</small>
                    </div>
                }
            </div>

            <div className='flip_icon'>
                {
                  info?.tracker.frt?
                    <div className='sail'>
                      <Home id='icon_'/>
                      <small>delivered</small>
                    </div>
                    :
                    <div className='sail'>
                      <Error id='icon_'/>
                      <small>pending</small>
                    </div>
                }    
            </div>
        </div>
        <p style={{color:'grey', margin:'10px'}}>Processed Shipped En Route Arrived</p>
        </div>
        



        <div className='other_details'>
          <div className='detail_box'>
              <h3>SHIPMENT DETAILS</h3>
              <div className='lit'>
                <h3>Qauntity : <span>{info?.tracker.quantity}</span></h3>
                <h3>Service Type : <span>{info?.tracker.servicetype}</span> </h3>
                <h3>Weight : <span>{info?.tracker.packageweight}</span></h3>
                <h3>Description : <span>{info?.tracker.packagename}</span></h3>
              </div>
          </div>


          <div className='detail_box'>
              <h3>DESTINATION</h3>
              <div className='lit'>
                <h3>Receiver Name : <span>{info?.tracker.recieversname}</span></h3>
                <h3>Receiver Email :  <span>{info?.tracker.recieversemail}</span></h3>
                <h3>Receiver Address : <span>{info?.tracker.recieverslocation}</span></h3>
                <h3>Expected Date of Delivery : <span>{info?.tracker.time}</span></h3>
              </div>
          </div>


          <div className='detail_box'>
              <h3>ORIGIN</h3>
              <div className='lit'>
                <h3>Sender Name : <span>{info?.tracker.sendersname}</span></h3>
                <h3>Sender Email : <span>{info?.tracker.sendersemail}</span></h3>
                <h3>Senders Address : <span>{info?.tracker.senderslocation}</span></h3>
                <h3>Location : <span>{info?.tracker.companylocation}</span> </h3>
                <h3>Expected Date of Delivery : <span>{info?.tracker.time}</span></h3>
                <h3>shipment Date : {info?.tracker.shippeddate}</h3>
              </div>
          </div>
          
        </div>

        <div className='packageimg' style={{width:'95%'}}> 
        <h3>CURRENT LOCATION</h3>
        <MapContainer
              center={center}
              zoom={ZOOM_LEVEL}
              whenCreated={mapInstance => { mapref.current = mapInstance; }}
              style={{ height: "400px", width: "100%" }}
            >
              <TileLayer url='https://api.maptiler.com/maps/basic-v2/256/{z}/{x}/{y}.png?key=Ftn6h7lYJRZsJMTmqRI6' attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' />

              <Marker position={center}>
                <Popup>
                  Parcel current location.
                </Popup>
              </Marker>
        </MapContainer>

        </div>

        {/* { info?.tracker.img ?
          <div className='packageimg'> 
            <img src={info?.tracker.img} alt='' />
          </div>
          :
          null
        } */}


       
      

        </div>


        
        :
          <div className='null'>
          <div className='track_bod2'>
            <img className='secu' src={secu} alt='' />
            <h3>Can't find track id</h3>
            <p>This happened for security reason </p>
            <small>please go back and reload the page thank you</small>
            <p>Go back 
              <Link to='/'>
                <p>/Home</p>
              </Link>
            </p>
          </div>
          </div>
      }

    </div>
  )
}

export default Popups